import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import pj from '../../../package.json';
import * as api from 'api';
import Loader from 'components/Loader';

const Preload = ({ children }) => {
	const appDictionary = api.mw.app.appDictionaries.useQuery();

	useEffect(() => {
		const storageVersion = localStorage.getItem('version');

		if (storageVersion !== pj.version) {
			localStorage.clear();
			sessionStorage.clear();
			localStorage.setItem('version', pj.version);
		}
	}, []);

	const isLoading = appDictionary.isLoading;

	return isLoading
		? (
			<Loader withContainer />
		)
		: children;
};

Preload.propTypes = {
	children: PropTypes.node.isRequired,
};

export default Preload;